module.exports = __webpack_public_path__ + "img/walker frame.f615ac24.svg";